// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AccountMenuButton-cls1__b775d221ddfe65f0d670{/*!*/}.AccountMenuButton-cls2___3e5851965b14b894610{width:24px;width:var(--spacing-sm-24, 24px);height:24px;height:var(--spacing-sm-24, 24px);border-radius:50%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AccountMenuButton-cls1__b775d221ddfe65f0d670",
	"cls2": "AccountMenuButton-cls2___3e5851965b14b894610 AccountMenuButton-cls1__b775d221ddfe65f0d670"
};
export default ___CSS_LOADER_EXPORT___;
